/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlPrePurchaseProductSpecification
 */
export interface ControlPrePurchaseProductSpecification {
    /**
     * 
     * @type {string}
     * @memberof ControlPrePurchaseProductSpecification
     */
    product_id: string;
    /**
     * 
     * @type {number}
     * @memberof ControlPrePurchaseProductSpecification
     */
    quantity: number;
}

/**
 * Check if a given object implements the ControlPrePurchaseProductSpecification interface.
 */
export function instanceOfControlPrePurchaseProductSpecification(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "product_id" in value;
    isInstance = isInstance && "quantity" in value;

    return isInstance;
}

export function ControlPrePurchaseProductSpecificationFromJSON(json: any): ControlPrePurchaseProductSpecification {
    return ControlPrePurchaseProductSpecificationFromJSONTyped(json, false);
}

export function ControlPrePurchaseProductSpecificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlPrePurchaseProductSpecification {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'product_id': json['product_id'],
        'quantity': json['quantity'],
    };
}

export function ControlPrePurchaseProductSpecificationToJSON(value?: ControlPrePurchaseProductSpecification | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'product_id': value.product_id,
        'quantity': value.quantity,
    };
}

